/* lua.js generated code undefined */
let ManualLocationPanel = require("clover/panel/location/ManualLocationPanel")
let ManualLocationExplainPanel = require("clover/panel/location/ManualLocationExplainPanel")


LocationManager = xClass("LocationManager")
let instance = null
LocationManager.getInstance = function () {
    let self = this
    if (instance) {
        return instance
    }
    instance = LocationManager.create()
    instance.init()
    return instance
}
LocationManager.prototype.init = function () {
    let self = this
}

LocationManager.STATE = {
    ONE: 2, // 只有一个城市信息 定位准确
    MANUAL: 3, // 手动定位中
    CAN_SELECT: 1, //可选
}
LocationManager.prototype.getState = function () {
    let location = UserManager.getInstance().location
    let locationList = location.locationList || {}
    let nextChooseTime = location.nextChooseTime || 0
    cc.log("[location]", "LocationManager getState location",location); 
    cc.log("[location]", "LocationManager getState locationList",locationList,nextChooseTime); 

    if (nextChooseTime >= Localhost.time()){
        return LocationManager.STATE.MANUAL
    }else if(locationList.length > 1){
        return LocationManager.STATE.CAN_SELECT

    }else{
        return LocationManager.STATE.ONE
    }
}

LocationManager.prototype.isOpen = function () {
    let locationConfig = MetaManager.getManualLocationConfig()
    let location_platform_arr = locationConfig.location_platform_arr || []
    let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    for (let i = 0; i < location_platform_arr.length; i++) {
        if (pf == location_platform_arr[i]){
            cc.log("[location]", "isOpen 渠道开启  ", pf)
            return true;
        }        
    }
    cc.log("[location]", "isOpen 渠道未开启  ", pf)
    cc.log("[location]", "isOpen 渠道未开启  location_platform_arr ", location_platform_arr)

    return false
}
LocationManager.prototype.getProvinceName = function () {
    let location = UserManager.getInstance().location
    let province = location.province == 0 ? "其它" :location.province
    return province
    
}
//显示手动选择界面
LocationManager.prototype.showManualLocationPanel = function (cb,data) {
    let onResLoad = ()=>{
        let panel = ManualLocationPanel.create(data)
        panel.popup(true,null,()=>{
            cc.log("[location]", "LocationManager showManualLocationPanel cb ***********"); 
            if (cb) cb()
        })
    }
    
    ManualLocationPanel.preloadRes(onResLoad);
}

LocationManager.prototype.showExplainPanel = function (cb) {
    let panel = ManualLocationExplainPanel.create()
    panel.popup(true,null,()=>{
        cc.log("[location]", "LocationManager showExplainPanel cb ***********"); 
        if (cb) cb()
    })
   

}


LocationManager.prototype.chosseLocation = function (location,onSuccess, onFail) {
    let self = this
    let onSuccessCb = (evt) => {
        cc.log("[location]", "LocationManager chosseLocation onSuccessCb evt", evt);
        if (evt && evt.data){
            let data = evt.data
            UserManager.getInstance().updateLocation(data)
        }
        
        if (onSuccess)onSuccess(evt.data);
    }
    let onFailCb = (evt) => {
        cc.log("[location]", "LocationManager chosseLocation onFailCb evt", evt);
        if (evt && evt.data){
            if (tonumber(evt.data)>0){
                Toast.make(getText("error.tip."+evt.data.toString()));
            }else{
                Toast.make(getText("error.tip.-1"));
            }
        }
        if (onFail)onFail(evt);
    }
    var http = ChooseUserLocationHttp.new();
    http.addEventListener(Events.kComplete, onSuccessCb);
    http.addEventListener(Events.kError, onFailCb);
    http.addEventListener(Events.kCancel, onFailCb);
    http.load(location);

}

// ------------------------------------------------------------------------------------------
// -- dc
LocationManager.dcClickIcon = function() {
    let params = {}
    params.type  = "click"
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("location", "click", DCAssist.paramsUtil(params))
}

LocationManager.dcPageShow = function() {
    let params = {}
    params.type    = LocationManager.getInstance().getState()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("location", "page_show", DCAssist.paramsUtil(params))
}

LocationManager.dcLocationClick = function(num,t1,t2) {
    let params = {}
	params.num   = num
    params.sub_level    = t1 //切换前城市
	params.goal    = t2 //切换后城市
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("location", "location_click", DCAssist.paramsUtil(params))
}



LocationManager.dcNoteClick = function() {
    let params = {}
    params.type    = "click"
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("location", "note_click", DCAssist.paramsUtil(params))
}

